module.exports = __webpack_public_path__ + "static/img/logo30.b52ae0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo30.png
// module id = FFd3
// module chunks = 1